import styled from 'styled-components';
import React from 'react';
import {
  Banner,
  COLORS,
  GenericIconName,
  Icon,
  Text,
} from '@aboutyou/ui-components';
import {useTranslation} from '@aboutyou/i18n';
import {useShouldShowPDLoginBanner} from './hooks/useShouldShowPDLoginBanner';

const SalesIconWrapper = styled.div`
  padding-right: 16px;
`;

const StyledContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const InfoBanner = () => {
  const {t} = useTranslation();
  const shouldShowPDLoginBanner = useShouldShowPDLoginBanner();

  return shouldShowPDLoginBanner ? (
    <Banner dataTestid={'loginInfoModal'} backgroundColor={COLORS.Yellow}>
      <StyledContentWrapper>
        <SalesIconWrapper>
          <Icon size={'S'} asset={GenericIconName.Sale} fill={COLORS.Black} />
        </SalesIconWrapper>
        <Text
          size="px12"
          dangerouslySetInnerHTML={{
            __html: t(
              'Bitte logge Dich ein, damit wir prüfen können, ob Dein Konto&nbsp;<strong>Sonderrabatte</strong>&nbsp;hat🎉',
            ),
          }}
        />
      </StyledContentWrapper>
    </Banner>
  ) : null;
};
